var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.996 7.81055H12.005M4 10.8105V19.3105M8 10.8105V19.3105M16 10.8105V19.3105M20 10.8105V19.3105M2 9.38055C2 8.18355 2.482 7.45055 3.48 6.89455L7.59 4.60755C9.743 3.41055 10.82 2.81055 12 2.81055C13.18 2.81055 14.257 3.41055 16.41 4.60755L20.52 6.89455C21.517 7.45055 22 8.18355 22 9.38055C22 9.70455 22 9.86755 21.965 10.0005C21.779 10.7005 21.144 10.8115 20.531 10.8115H3.469C2.856 10.8115 2.222 10.7015 2.035 10.0005C2 9.86655 2 9.70455 2 9.38055ZM19 19.3105H5C4.20435 19.3105 3.44129 19.6266 2.87868 20.1892C2.31607 20.7518 2 21.5149 2 22.3105C2 22.4432 2.05268 22.5703 2.14645 22.6641C2.24021 22.7579 2.36739 22.8105 2.5 22.8105H21.5C21.6326 22.8105 21.7598 22.7579 21.8536 22.6641C21.9473 22.5703 22 22.4432 22 22.3105C22 21.5149 21.6839 20.7518 21.1213 20.1892C20.5587 19.6266 19.7956 19.3105 19 19.3105Z",
    stroke: "#FF395D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/Bank.99612a98d50c1039e0c956b7faa38189.svg";
export { ForwardRef as ReactComponent };